firebird.factory('videoVoiceCallService', [
    '$rootScope',
    '$timeout',
    '$window',
    'logService',
    'attendeeService',
    'connectivityService',
    'socketService',
    'helperService',
    'localStreamManagerService',
    'avDeviceService',
    'storageService',
    'analyticsWrapperService',
    'videoGlobalService',
    'executionEnvironmentEnum',
    function (
        $rootScope,
        $timeout,
        $window,
        logService,
        attendeeService,
        connectivityService,
        socketService,
        helperService,
        localStreamManagerService,
        avDeviceService,
        storageService,
        analyticsWrapperService,
        videoGlobalService,
        executionEnvironmentEnum
    ) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoVoiceCallService');

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // local SIP URI for SIP plugin
            self.localuri = null;

            // target SIP URI for SIP plugin
            self.remoteuri = null;

            // SIP plugin handle
            self.sipcall = null;

            // this participant's SIP plugin publishing stream (local media stream).
            // this gets muted after call is started to stop publishing via SIP plugin.
            // but this is needed so that SIP plugin can negotiate video along with audio.
            self.mystream1 = null;

            self.startVoiceCall = startVoiceCall;
            self.restartSipCallRetry = 0;
            self.restartSipCallMaxRetries = 10;
            self.restartSipCallTimer = null;
            self.cancelRestartSipCallTimer = cancelRestartSipCallTimer;
            self.restartScreenSipCallRetry = 0;
            self.restartScreenSipCallMaxRetries = 10;
            self.restartScreenSipCallTimer = null;
            self.cancelRestartScreenSipCallTimer = cancelRestartScreenSipCallTimer;
            self.recreateSipPlugin = recreateSipPlugin;
            self.handleSipPluginError = handleSipPluginError;

            self.createOfferForSIP = createOfferForSIP;
            self.onCreateOfferForSIPError = onCreateOfferForSIPError;
            self.clearSipReconnectTimeout = clearSipReconnectTimeout;
            self.sipReconnectTimeout = null;

            self.doHangup = doHangup;

            self.stopAllLocalTracks = stopAllLocalTracks;
            self.unmuteVideoOnReconnect = false;
        }

        function stopAllLocalTracks() {
            if (self.mystream) {
                self.mystream.getTracks().forEach(function (track) {
                    track.stop();
                });
            }
            if (self.mystream1) {
                self.mystream1.getTracks().forEach(function (track) {
                    track.stop();
                });
            }
        }

        // Every web participant's client joins the video room plugin AND the SIP plugin - so that
        // the Janus server can create a SIP call to the MCU, representing this participant. Initially,
        // video publish is enabled on the SIP plugin, so that the SIP call is negotiated with video
        // enabled. If the newplugin is used, then the video publish is disabled to the SIP plugin,
        // because the new plugin re-uses the video stream of video room handle to the SIP handle.
        //
        // Create a connection to the SIP plugin, to initiate a call to the MCU. Also process all the
        // received events and messages from that plugin.
        //
        // Note that both video publisher and screen share publisher need separate SIP calls. The is_screen
        // argument indicates whether this is called for screen share or not?
        function startVoiceCall(is_screen, skipStartVideoPublish) {
            var disconnectRetrySIP = 0;

            var plugin = null;
            if (!is_screen) {
                //we don't do the analytics call for the voice leg of the screen share call
                analyticsWrapperService.eventTrack('Meeting - sip voice call - starting', { sfuEvent: true });
            }

            self.janus.attach({
                plugin: self.newplugin ? 'janus.plugin.anymeeting' : 'janus.plugin.sip',
                handle_type: 'sip',
                opaqueId: self.opaqueId,
                success: function (pluginHandle) {
                    logService.log('videoroomCtrl Janus-to-FS call complete');
                    if (!is_screen) {
                        analyticsWrapperService.eventTrack('Meeting - sip voice call - connected', { sfuEvent: true });
                    } else if (!self.screenshare) {
                        logService.log('videoroomCtrl sip screen, screenshare has stopped, so should screensipcall');
                        plugin = pluginHandle; // do not assign to self.screensipcall
                        plugin.state = {};
                        self.detachPlugin(plugin);
                        return;
                    }

                    // store the plugin handle.
                    if (is_screen) {
                        plugin = self.screensipcall = pluginHandle;
                    } else {
                        plugin = self.sipcall = pluginHandle;
                        plugin.iceConnectionAttempts = 0;
                    }
                    logService.log(
                        'videoroomCtrl sip ' +
                            (is_screen ? 'screen' : '') +
                            ' plugin attached! (' +
                            plugin.getPlugin() +
                            ', id=' +
                            plugin.getId() +
                            ')'
                    );

                    // do not perform actual SIP register (type=guest), but configure the local SIP URI,
                    // and other parameters.
                    var register = {
                        request: 'register',
                        type: 'guest',
                        username: self.localuri
                    };

                    // TODO: if the same local SIP URI is used for two calls, then the Janus-FreeSwitch treats
                    // them as one item, and when one call is closed, other call gets closed too. Hence,
                    // change the local SIP URI of the screen share call.
                    if (is_screen) {
                        register.username = register.username.replace(/^sip:/, 'sip:screen-');
                    }

                    sendToSipPlugin(is_screen, { message: register });
                    plugin.state = {};
                    plugin.state.call = 'registering';
                },
                error: function (error) {
                    logger.error('startVoiceCall->janus.attach.error', 'sip error attaching plugin...', error);
                    if (!is_screen) {
                        analyticsWrapperService.eventTrack('Meeting - sip voice call - error', { sfuEvent: true });
                    }

                    if (self.shouldReattachPluginAfterError(error)) {
                        $timeout(() => self.recreateSipPlugin(is_screen), 0);

                        // videoConnectService.coreError will not be called
                        return true;
                    }

                    return false;
                },
                mediaState: function (medium, on) {
                    logService.log(
                        'videoroomCtrl sip plugin ' + (on ? 'started' : 'stopped') + ' receiving our ' + medium
                    );
                    if (plugin) {
                        if (medium == 'audio') {
                            plugin.state.media = !!on;

                            if (on) {
                                if (is_screen) {
                                    self.restartScreenSipCallRetry = 0;
                                    self.cancelRestartScreenSipCallTimer();
                                } else {
                                    self.restartSipCallRetry = 0;
                                    self.cancelRestartSipCallTimer();
                                }
                            }

                            if (on && !plugin.state.mediaInitiated) {
                                plugin.state.mediaInitiated = self.iceMediaInitiated = true;
                            }
                        }
                    }
                },
                webrtcState: function (on, reason) {
                    logService.log(
                        'videoroomCtrl sip plugin says our WebRTC PeerConnection is ' +
                            (on ? 'up' : 'down') +
                            ' now, reason=' +
                            reason
                    );

                    if (
                        self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix &&
                        !on &&
                        reason === 'DTLS alert'
                    ) {
                        // TODO: may also be received due to lower network layer disconnection, in which case do we want to reconnect?
                        logService.log('VDI - leave meeting when xendesktop is disconnected');
                        $rootScope.$broadcast('leave-meeting-without-prompt');
                        return;
                    }

                    if (
                        self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix &&
                        !on &&
                        !attendeeService.getIsVideoMuted()
                    ) {
                        // VDI - Mute webcam on network disconnection; webcam is unmuted after reconnection.
                        logService.log('VDI - Muting video on plugin hangup');
                        $rootScope.$broadcast('enable-video-on-reconnect', false);
                        self.unmuteVideoOnReconnect = true;
                    }

                    if (plugin) {
                        plugin.state.webrtc = !!on;
                    }

                    var plugin0 = (is_screen && self.screensipcall) || (!is_screen && self.sipcall);
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log('videoroomCtrl sip, ignoring webrtcState ' + on + ' as not for current plugin');
                        return;
                    }

                    if (!is_screen) {
                        self.sendStatsUpdate(on, plugin);
                    }
                },
                iceState: function (state) {
                    logService.log(
                        'videoroomCtrl sip ' + (is_screen ? 'screen' : '') + ' iceConnectionState updated:',
                        state
                    );

                    if (plugin) {
                        plugin.state.ice = state;
                    }

                    var plugin0 = (is_screen && self.screensipcall) || (!is_screen && self.sipcall);
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log('videoroomCtrl sip, ignoring iceState ' + state + ' as not for current plugin');
                        self.iceRestartCancel(plugin);
                        return;
                    }

                    if (!is_screen) {
                        connectivityService.updateJanusIceState(state, 'sipcall');
                        connectivityService.sendIceConnStateToServer(state, self.getJanusConnectionState());

                        switch (state) {
                            case 'checking':
                                if (plugin) {
                                    plugin.iceConnectionAttempts++;
                                    logService.log(
                                        'videoroomCtrl sip ' +
                                            (is_screen ? 'screen' : '') +
                                            ' - increasing iceConnectionAttempts'
                                    );
                                }
                                break;
                            case 'closed':
                            case 'disconnected':
                                if (plugin) {
                                    if (plugin.iceConnectionAttempts >= 3) {
                                        logService.log(
                                            'videoroomCtrl sip ' +
                                                (is_screen ? 'screen' : '') +
                                                ' - iceConnectionAttempts max attempts reached'
                                        );
                                        plugin.state.abortRetry = true;
                                        self.setPhoneOnlyState();
                                    }
                                }
                                break;
                            case 'connected':
                                if (plugin && plugin.webrtcStuff) {
                                    logService.log(
                                        'videoroomCtrl applying getStats to audio peer connection',
                                        plugin.webrtcStuff.pc.getStatsApplied
                                    );
                                    self.applyGetStats(plugin.webrtcStuff.pc, connectivityService.callMediaTypes.SFU, {
                                        transmissionType: 'all',
                                        mediaType: 'audio'
                                    });
                                }

                                if (avDeviceService.isAudioDeviceBlocked() || avDeviceService.isVideoDeviceBlocked()) {
                                    avDeviceService.showBlockedPermissionsBanner();
                                }

                                if (plugin) {
                                    plugin.iceConnectionAttempts = 0;
                                }
                                break;
                            case 'completed':
                                if (plugin) {
                                    plugin.iceConnectionAttempts = 0;
                                }
                                break;
                        }
                    }

                    if (plugin) {
                        if (state == 'disconnected' && !is_screen) {
                            if (
                                plugin.iceConnectionAttempts == 0 ||
                                (!self.iceTransportSwitchedToTCP &&
                                    !self.iceMediaInitiated &&
                                    self.iceTransportOnTCP > 1)
                            ) {
                                self.iceRestartAfter(plugin, 'audio', is_screen);
                            } else {
                                self.iceRestartCancel(plugin); // cancel in case it was active.
                            }
                        } else if (state == 'connected' && !is_screen) {
                            self.iceRestartCancel(plugin);
                        }
                    }
                },
                slowLink: function (uplink, lost) {
                    var plugin0 = (is_screen && self.screensipcall) || (!is_screen && self.sipcall);
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log('videoroomCtrl sip, ignoring slowLink as not for current plugin');
                        return;
                    }

                    if (!is_screen) {
                        // Janus' uplink attribute is opposite of what the client interprets.
                        self.onSlowLink('audio', !uplink, lost);
                    }
                },
                onmessage: function (msg, jsep) {
                    logService.log('videoroomCtrl sip, got a message (publisher)');
                    var plugin0 = (is_screen && self.screensipcall) || (!is_screen && self.sipcall);

                    // in case of any error in the SIP plugin, hangup the SIP call.
                    // TODO: this should also cause it to terminate the video call.
                    if (msg.error) {
                        if (!plugin0 || plugin !== plugin0) {
                            // the event may be on old deleted plugin handle
                            logService.warn(
                                'videoroomCtrl sip, ignoring error as not for current plugin: ' + msg.error
                            );
                            plugin.state.call = 'terminated';
                            plugin.hangup();
                            return;
                        }

                        logger.error('startVoiceCall->janus.attach.onmessage', 'sip error', msg.error);
                        self.handleSipPluginError(msg, is_screen);
                        return;
                    }

                    var result = msg.result || {};
                    var event = (msg.result && msg.result.event) || null;
                    if (event == 'registration_failed') {
                        logger.error('startVoiceCall->janus.attach.onmessage', 'sip registration failed', result);
                        plugin.state.call = 'register-failed';
                        self.showAlert(result.code + ' ' + result.reason);
                    } else if (event == 'registered') {
                        // When registration is success, initiate a call.
                        logService.log('videoroomCtrl sip registered, initiate call...');

                        plugin.state.call = 'registered';
                        self.msgflowEvent('peer-connection:reg', { type: 'audio', reason: 'on registered' });
                        self.createOfferForSIP(is_screen);

                        // TODO: should use self.videoEnabled instead of !getIsVideoMuted()
                        if (
                            !is_screen &&
                            !skipStartVideoPublish &&
                            (!attendeeService.getIsVideoMuted() || self.mediapath == 'sfu')
                        ) {
                            // video room publish is initiated if needed.
                            self.startVideoPublish();

                            if (self.testvideos) {
                                self.testvideosStartPublish();
                            }
                        }
                    } else if (event == 'calling') {
                        logService.log('videoroomCtrl sip, waiting for the peer to answer...');
                        plugin.state.call = 'calling';
                    } else if (event == 'progress') {
                        logService.log(
                            "videoroomCtrl sip, there's early media from " + result.username + ', waiting for the call!'
                        );
                        logService.log(jsep);
                        if (jsep !== null && jsep !== undefined) {
                            if (
                                is_screen &&
                                !self.fileplay &&
                                self.reuseScreenSDP.enable &&
                                self.reuseScreenSDP.saved
                            ) {
                                logService.log('videoroomCtrl sip, ignoring SDP, was reused');
                            } else {
                                self.customizeSdp(jsep, undefined, is_screen, true, true);
                                plugin.handleRemoteJsep({
                                    jsep: jsep,
                                    error: is_screen ? self.doScreenHangup : self.doHangup
                                });
                            }
                        }
                    } else if (event == 'accepted') {
                        logService.log('videoroomCtrl sip, ' + result.username + ' accepted the call!');
                        logService.log(jsep);

                        plugin.state.call = 'accepted';
                        // Call can start, now: handle the remote answer
                        if (jsep !== null && jsep !== undefined) {
                            if (
                                is_screen &&
                                !self.fileplay &&
                                self.reuseScreenSDP.enable &&
                                self.reuseScreenSDP.saved
                            ) {
                                logService.log('videoroomCtrl sip, ignoring SDP, was reused');
                            } else {
                                self.customizeSdp(jsep, undefined, is_screen, true, true);
                                plugin.handleRemoteJsep({
                                    jsep: jsep,
                                    error: is_screen ? self.doScreenHangup : self.doHangup
                                });
                            }
                        }

                        // for screen video, video call is done first, and then sip call, hence must inform
                        // server to attach videoroom now.
                        if (self.sendScreenVideoToFS) {
                            self.attachVideoRoomToSIP(true, true);
                        }

                        if (disconnectRetrySIP > 0) {
                            disconnectRetrySIP = 0;
                        }

                        $rootScope.$broadcast('sfu-sip-connected');

                        if (self.showConnectedOverlayOnSipAccept) {
                            self.showConnectedOverlayOnSipAccept = false;
                            self.showConnectedOverlay();
                        }

                        if (self.hideSideBar && $window.$('aside#sidebar-left').hasClass('toggled')) {
                            $window.$('#sidebar-toggle-button').click();
                        }
                    } else if (event === 'updatingcall') {
                        // Auto accept a re-INVITE is possible.
                        logService.log('videoroomCtrl sip, got re-INVITE');
                        var doAudio = jsep.sdp.indexOf('m=audio ') > -1,
                            doVideo = jsep.sdp.indexOf('m=video ') > -1;
                        plugin.createAnswer({
                            jsep: jsep,
                            media: { audio: doAudio, video: doVideo },
                            success: function (jsep) {
                                logService.log(
                                    'videoroomCtrl sip, got SDP ' +
                                        jsep.type +
                                        '! audio=' +
                                        doAudio +
                                        ', video=' +
                                        doVideo
                                );
                                logService.log(jsep);
                                var body = { request: 'update' };
                                sendToSipPlugin(is_screen, { message: body, jsep: jsep });
                            },
                            error: function (error) {
                                logger.error(
                                    'startVoiceCall->plugin.createAnswer.onmessage',
                                    'sip in createAnswer, WebRTC error',
                                    error
                                );
                            }
                        });
                    } else if (event === 'hangup') {
                        // TODO: when server terminates the SIP call, it should also hangup the video room plugin.
                        if (!plugin0 || plugin !== plugin0) {
                            // the event may be on old deleted plugin handle
                            logService.log(
                                'videoroomCtrl sip, ignoring hangup as not for current plugin: ' +
                                    result.code +
                                    ' ' +
                                    result.reason
                            );
                            plugin.state.call = 'terminated';
                            plugin.hangup();
                            return;
                        }

                        logService.log('videoroomCtrl sip, call hung up (' + result.code + ' ' + result.reason + ')!');

                        var abortSipRetry = !is_screen && plugin && plugin.state.abortRetry == true;

                        if (
                            !abortSipRetry &&
                            (result.code == 200 ||
                                result.code == 503 ||
                                result.code == 408 ||
                                result.code == 420 ||
                                result.code == 410)
                        ) {
                            // may also check for result.reason == 'Session Terminated'
                            // normal call termination - if videoroom is connection after a timeout,
                            // then attempt to reconnect the SIP plugin.

                            $rootScope.$broadcast('sfu-sip-disconnected');
                            plugin.state.call = 'disconnected';

                            var timeoutLength = Math.min(60000, 1000 * Math.pow(2, disconnectRetrySIP));
                            timeoutLength =
                                timeoutLength <= 8000
                                    ? timeoutLength
                                    : timeoutLength - 4000 + Math.floor(8000 * Math.random());
                            logService.log('videoroomCtrl sip reconnect, will retry in ' + timeoutLength + ' ms');

                            self.clearSipReconnectTimeout(plugin);

                            plugin.sipReconnectTimeout = $timeout(function () {
                                plugin.sipReconnectTimeout = null;

                                if (helperService.getIsMeetingEnding()) {
                                    logService.log(
                                        'videoroomCtrl sip, meeting ending... returning from sip reconnect timeout'
                                    );
                                    return;
                                }

                                if (self.janus && self.janus.isConnected()) {
                                    logService.log(
                                        'videoroomCtrl sip reconnect, reattempting sip call after unexpected hangup.'
                                    );
                                    if (disconnectRetrySIP < self.disconnectMaxRetriesSIP) {
                                        disconnectRetrySIP += 1;
                                        plugin.state.call = 'reconnecting';
                                        if (!is_screen) {
                                            self.msgflowEvent('peer-connection:sip', {
                                                type: 'audio',
                                                reason: 'SIP reconnect'
                                            });
                                        }
                                        self.createOfferForSIP(is_screen);
                                        self.showConnectingOverlay();
                                    } else {
                                        $rootScope.$broadcast('sfu-sip-gave-up');
                                    }
                                } else {
                                    logService.log(
                                        'videoroomCtrl sip, ignoring sip call hangup, as janus is disconnected.'
                                    );
                                }
                            }, timeoutLength);
                        } else {
                            logService.log('videoroomCtrl sip hangup: ' + result.code + ' ' + result.reason);
                            plugin.state.call = 'terminated';
                            plugin.hangup();

                            if (result.code == 488) {
                                logger.error(
                                    'startVoiceCall->plugin.createAnswer.onmessage',
                                    'audio or video codec not supported',
                                    self.audiocodec,
                                    self.videocodec
                                );
                                $rootScope.$broadcast('sfu-sip-gave-up');
                            }
                        }
                    }
                },
                onlocalstream: function (stream) {
                    // When local stream is created.
                    logService.log('videoroomCtrl sip, got local stream');
                    logService.log(stream);
                    if (!is_screen) {
                        self.mystream1 = stream;
                    }

                    // used for prevent appearing red exclamation mark when switching microphone
                    avDeviceService.setIsMicrophoneDeviceSwitching(false);

                    // Janus.attachMediaStream($window.$('#videolocal').get(0), stream);

                    // $('#videolocal').get(0).muted = 'muted';
                    var videoTracks = stream.getVideoTracks();
                    if (videoTracks === null || videoTracks === undefined || videoTracks.length === 0) {
                        logger.warn('startVoiceCall->janus.attach.onlocalstream', 'sip, no video track');
                    }

                    var audioTracks = stream.getAudioTracks();
                    if (audioTracks === null || audioTracks === undefined || audioTracks.length === 0) {
                        logger.warn('startVoiceCall->janus.attach.onlocalstream', 'sip, no audio track');
                    } else if (!is_screen) {
                        var audioTrackSettings =
                            audioTracks[0] && audioTracks[0].getSettings ? audioTracks[0].getSettings() : null;
                        if (audioTrackSettings && audioTrackSettings.deviceId) {
                            logService.log('videoroomCtrl sip, audio track deviceId: ' + audioTrackSettings.deviceId);

                            if (avDeviceService.getSfuDeviceErrorFromId(audioTrackSettings.deviceId)) {
                                avDeviceService.clearSfuDeviceError(audioTrackSettings.deviceId);
                            }

                            $rootScope.$broadcast('janus-local-media-stream-created', { type: 'audio' });
                        }

                        self.updateLocalAudioState();

                        if (self.mediapath != 'sfu') {
                            // for mediapath of 'sfu', do not use this audioTrack.
                            //Calling replaceLocalVideoTrack will make sure the audio track has an ended event listener
                            //and an event gets broadcasted to other services/controllers
                            localStreamManagerService.replaceLocalAudioTrack(audioTracks[0]);

                            //Cloned stream used for local audio level tracking while muted
                            localStreamManagerService.setClonedAudioStream(stream);
                        }

                        //Indicates state of microphone connectivity
                        socketService.send({
                            message: 'attendee-device-connections-updated',
                            data: {
                                deviceConnections: {
                                    audioConnected: true
                                }
                            }
                        });

                        logService.log(
                            'videoroomCtrl sending attendee-mediastats for audioIn: ' + audioTracks[0].label
                        );
                        socketService.send({
                            message: 'attendee-mediastats',
                            data: { audioIn: audioTracks[0].label }
                        });
                    }

                    if (is_screen) {
                        // mute the audio and video if this is for screen sharing.
                        if (!self.fileplay || self.mediapath == 'sfu') {
                            // but not if fileplay AND not mediapath of 'sfu'
                            self.screensipcall.muteAudio();
                        }
                        self.screensipcall.muteVideo();
                    } else {
                        if (self.mediapath == 'sfu') {
                            // audio sent in video stream, so mute here.
                            self.sipcall.muteAudio();
                        }
                        self.sipcall.muteVideo();
                    }
                    if (self.newplugin) {
                        // ANYAM-13764 - so that SDP has video, and then track is removed for older Chrome version 66
                        $timeout(function () {
                            if (self.mediapath == 'sfu') {
                                // audio sent in video stream, so remove here.
                                if (audioTracks && audioTracks.length > 0) {
                                    audioTracks[0].stop();
                                }
                            }
                            if (videoTracks && videoTracks.length > 0) {
                                videoTracks[0].stop();
                            }
                        }, 0);
                    }
                },
                onremotestream: function (stream) {
                    // When remote stream is received for a remote feed (not screen share), then
                    // attach it to the audio element, so that mixed audio from MCU is played.

                    logService.log('videoroomCtrl sip, got a remote stream');
                    logService.log(stream);

                    // crossbrowser compatibility check. firefox sometimes calls this with stream of undefined.
                    if (!helperService.isFirefox() || stream) {
                        plugin.state.remotestream = true;

                        if (!is_screen && $window.$('#videoroom-sipaudio').get(0)) {
                            $window.Janus.attachMediaStream($window.$('#videoroom-sipaudio').get(0), stream);
                            if (self.videoFromMcu) {
                                $window.Janus.attachMediaStream(self.videoFromMcu, stream);
                            }

                            let audioOutputId = storageService.get('audio-output-device');
                            if (audioOutputId && audioOutputId !== $window.$('#videoroom-sipaudio').get(0).sinkId) {
                                self.updateAudioOutputDevice();
                            }
                        }
                    }
                },
                ondetached: function () {
                    var plugin0 = (is_screen && self.screensipcall) || (!is_screen && self.sipcall);
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log('videoroomCtrl sip, ignoring ondetached as not for current plugin');
                        return;
                    }

                    // timeout needed to delay our detach(withRequest) after detach(noRequest) of janus.js to avoid error from server
                    if (is_screen) {
                        logger.warn(
                            'startVoiceCall->janus.attach.ondetached',
                            'sip plugin screen, got forced detached from server, we stop screenshare'
                        );
                        $timeout(function () {
                            self.stopScreenShare();
                        }, 0);
                    } else {
                        logger.warn(
                            'startVoiceCall->janus.attach.ondetached',
                            'sip plugin, got forced detached from server, we reconnect everything'
                        );
                        // TODO: saving screenshare for reconnection does not work, do not pass second param as true.
                        self.rejoinConferenceAfter('sip detached', 0);
                    }
                },
                oncleanup: function () {
                    logService.log('videoroomCtrl sip plugin, got a cleanup notification: we are unpublished now');
                    var plugin0 = (is_screen && self.screensipcall) || (!is_screen && self.sipcall);
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log('videoroomCtrl sip, ignoring oncleanup as not for current plugin');
                        plugin.state.call = 'closed';
                        self.iceRestartCancel(plugin);
                        return;
                    }

                    if (!is_screen) {
                        // stopMicLevel();
                        self.mystream1 = null;
                    }
                    plugin.state.call = 'closed';

                    self.iceRestartCancel(plugin);
                }
            });
        }

        function sendToSipPlugin(is_screen, callbacks) {
            const plugin = is_screen ? self.screensipcall : self.sipcall;

            if (callbacks.error === undefined) {
                callbacks.error = msg => {
                    logger.error('sendToSipPlugin', 'initial message', callbacks.message, 'response', msg);
                    self.handleSipPluginError(msg, is_screen);
                };
            }

            if (plugin) {
                plugin.send(callbacks);
            }
        }

        function handleSipPluginError(msg, is_screen) {
            switch (msg.error_code) {
                case 445: // JANUS_SIP_ERROR_ALREADY_REGISTERED
                case 447: // JANUS_SIP_ERROR_WRONG_STATE
                case 449: // JANUS_SIP_ERROR_LIBSOFIA_ERROR
                case 450: // JANUS_SIP_ERROR_IO_ERROR
                case 454: // JANUS_SIP_ERROR_NO_SUCH_CALLID
                case 459: // JANUS_ERROR_HANDLE_NOT_FOUND
                case 461: // JANUS_ERROR_PLUGIN_ATTACH
                case 462: // JANUS_ERROR_PLUGIN_MESSAGE (Request prohibitied by AnyMeeting)
                case 466: // JANUS_ERROR_TRICKE_INVALID_STREAM
                case 469: // JANUS_ERROR_UNEXPECTED_ANSWER
                case 471: // JANUS_SIP_ERROR_ALREADY_BACKEND
                case 472: // JANUS_SIP_ERROR_NO_BACKEND
                case 473: // JANUS_ERROR_PLUGIN_SESSION_NOT_FOUND
                case 500: // JANUS_ERROR_INTERNAL_ERROR
                case 502: // JANUS_ERROR_BAD_GATEWAY
                case 503: // JANUS_ERROR_SERVICE_UNAVAILABLE
                case 504: // JANUS_ERROR_GATEWAY_TIMEOUT
                    self.recreateSipPlugin(is_screen);
                    break;
                case 499: // JANUS_SIP_ERROR_UNKNOWN_ERROR
                    rejoinSipConference(msg, is_screen);
                    break;
                default:
                    break;
            }
        }

        function recreateSipPlugin(is_screen) {
            if (self.rejoinConferenceTimer) {
                logger.log(
                    'recreateSipPlugin',
                    `is_screen=${is_screen}: will not retry because we are in the rejoining state`
                );
                return;
            }

            self.retryWithExponentialBackoffAndLimit({
                count: is_screen ? self.restartScreenSipCallRetry : self.restartSipCallRetry,
                limit: is_screen ? self.restartScreenSipCallMaxRetries : self.restartSipCallMaxRetries,
                success: timeoutLength => {
                    logger.log('recreateSipPlugin', `is_screen=${is_screen}: will retry in ${timeoutLength} ms`);

                    if (is_screen) {
                        self.restartScreenSipCallRetry += 1;
                        self.cancelRestartScreenSipCallTimer();

                        self.restartScreenSipCallTimer = $timeout(function () {
                            self.restartScreenSipCallTimer = null;

                            if (self.rejoinConferenceTimer) {
                                logger.log(
                                    'recreateSipPlugin->retryWithExponentialBackoffAndLimit->success',
                                    'is_screen=true: will not retry because we are in the rejoining state'
                                );
                                return;
                            }

                            if (self.screensipcall) {
                                self.detachPlugin(self.screensipcall);
                                self.screensipcall = null;
                            }

                            self.startVoiceCall(true, true);
                        }, timeoutLength);
                    } else {
                        self.restartSipCallRetry += 1;
                        self.cancelRestartSipCallTimer();

                        self.restartSipCallTimer = $timeout(function () {
                            self.restartSipCallTimer = null;

                            if (self.rejoinConferenceTimer) {
                                logger.log(
                                    'recreateSipPlugin->retryWithExponentialBackoffAndLimit->success',
                                    'is_screen=false: will not retry because we are in the rejoining state'
                                );
                                return;
                            }

                            if (self.sipcall) {
                                self.detachPlugin(self.sipcall);
                                self.sipcall = null;
                            }

                            self.startVoiceCall(false, true);
                        }, timeoutLength);
                    }
                },
                error: () => {
                    self.showAlert(self.getContentShareErrorMessage(is_screen, true));
                }
            });
        }

        function rejoinSipConference(msg, is_screen) {
            if (self.rejoinConferenceTimer) {
                logger.log(
                    'rejoinSipConference',
                    `is_screen=${is_screen}: will not retry because we are in the rejoining state`
                );
                return;
            }

            self.retryWithExponentialBackoffAndLimit({
                count: is_screen ? self.restartScreenSipCallRetry : self.restartSipCallRetry,
                limit: is_screen ? self.restartScreenSipCallMaxRetries : self.restartSipCallMaxRetries,
                success: timeoutLength => {
                    if (is_screen) {
                        self.restartScreenSipCallRetry += 1;
                        self.cancelRestartScreenSipCallTimer();
                    } else {
                        self.restartSipCallRetry += 1;
                        self.cancelRestartSipCallTimer();
                    }

                    self.prepareForRejoinConference();
                    self.rejoinConferenceAfter(msg.error, timeoutLength, undefined, true);
                },
                error: () => {
                    self.prepareForRejoinConference();
                    $rootScope.$broadcast('sfu-ws-gave-up');
                }
            });
        }

        function cancelRestartSipCallTimer() {
            if (self.restartSipCallTimer) {
                $timeout.cancel(self.restartSipCallTimer);
                self.restartSipCallTimer = null;
            }
        }

        function cancelRestartScreenSipCallTimer() {
            if (self.restartScreenSipCallTimer) {
                $timeout.cancel(self.restartScreenSipCallTimer);
                self.restartScreenSipCallTimer = null;
            }
        }

        function clearSipReconnectTimeout(plugin) {
            if (plugin && plugin.sipReconnectTimeout) {
                $timeout.cancel(plugin.sipReconnectTimeout);
                plugin.sipReconnectTimeout = null;
            }
        }

        // refactor common code to a separate function.
        function createOfferForSIP(is_screen, iceRestart, deviceChange) {
            var plugin = is_screen ? self.screensipcall : self.sipcall;
            var stream;

            if (is_screen && self.screenstream) {
                stream = self.screenstream.clone();
            }

            if (!is_screen && !iceRestart) {
                if (plugin.sipAttempt === undefined) {
                    plugin.sipAttempt = 0;
                }

                plugin.sipAttempt++;
                logService.log(
                    'videoroomCtrl createOfferForSIP attempt number: ' +
                        plugin.sipAttempt +
                        ', deviceChange=' +
                        deviceChange
                );
            } else {
                logService.log(
                    'videoroomCtrl createOfferForSIP is_screen=' +
                        is_screen +
                        ' iceRestart=' +
                        iceRestart +
                        ' deviceChange=' +
                        deviceChange
                );
            }

            if (self.willSwitchDevice) {
                self.willSwitchDevice = false;
                avDeviceService.setIsMicrophoneDeviceSwitching(true);
            }

            var mediaConstraints = self.getMediaConstraints(
                iceRestart || deviceChange ? 'audio-change' : 'audio',
                is_screen
            );

            if (
                self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix &&
                deviceChange === 'switch-to-mic audio-change'
            ) {
                // VDI - user not able to join meeting if audio option is switched since sdk redirection gets suspended.
                // Hence need to rejoin the conference.
                logService.log('VDI - rejoin on switch to mic');
                self.rejoinConferenceIfNeeded('VDI mic switch');
                return;
            }

            if (helperService.getVDIRef().preventCreateOfferOnDeviceSwitch && deviceChange !== undefined) {
                // VDI - MIC/ webcam  gets disconnected when audio/video device is switched.
                // Hence preventing createOffer when deviceChange occurs.
                logService.log('VDI - ignore createOffer on deviceChange');
                return;
            }

            var onsuccess = function (jsep) {
                var plugin0 = is_screen ? self.screensipcall : self.sipcall;
                if (!plugin0 || plugin0 !== plugin) {
                    logService.log('videoroomCtrl sip got SDP for different plugin, ignoring.');
                    return;
                }

                logService.log('videoroomCtrl sip got SDP!');
                logService.log(jsep);

                if (!is_screen && !iceRestart) {
                    plugin.sipAttempt = 0;
                }

                if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix && self.unmuteVideoOnReconnect) {
                    // VDI - Unmute video after network reconnection if it was muted when network was lost.
                    logService.log('VDI - Unmuting video on network reconnection');
                    $rootScope.$broadcast('enable-video-on-reconnect', true);
                    self.unmuteVideoOnReconnect = false;
                }

                if (!iceRestart && !deviceChange) {
                    // The extra header tells MCU (FreeSwitch) to apply different dialplan steps.
                    // video vs screen for layout. video-mute and audio-mute for those states.
                    var items = [];
                    items.push(is_screen ? (!self.fileplay ? 'screen' : 'file') : 'video');
                    if (!is_screen) {
                        if (attendeeService.getIsAudioMuted()) {
                            items.push('audio-mute');
                        }
                    }
                    // This allows freeswitch to determine whether an attendee is a host or not
                    // Used for the join audio muted setting
                    if (attendeeService.getIsHost()) {
                        items.push('host');
                    }
                    // always join with video-mute, will be unmuted on attachvideoroom if needed.
                    items.push('video-mute');
                    var headers = {
                        'X-AM-SFU': items.join(' '),
                        'X-AM-SFU-ALID': '' + self.attendantLoginId,
                        'X-AM-SFU-ATTID': '' + self.attendantId
                    };

                    // initiate a call to MCU via the SIP plugin (or new plugin).
                    var body = {
                        request: 'call',
                        uri: self.remoteuri,
                        headers: headers,
                        autoaccept_reinvites: true
                    };

                    sendToSipPlugin(is_screen, { message: body, jsep: jsep });
                } else {
                    logService.log(
                        'videoroomCtrl sending sip update iceRestart=' + iceRestart + ' deviceChange=' + deviceChange
                    );
                    sendToSipPlugin(is_screen, { message: { request: 'update' }, jsep: jsep });
                }
            };

            var onerror = function (error) {
                var plugin0 = is_screen ? self.screensipcall : self.sipcall;
                if (!plugin0 || plugin0 !== plugin) {
                    logService.log('videoroomCtrl sip got SDP for different plugin, ignoring.');
                    return;
                }

                if (deviceChange) {
                    logger.error(
                        'createOfferForSIP->plugin.createOffer.error',
                        `sip plugin after ${deviceChange}, WebRTC error...`,
                        error
                    );

                    if (('' + deviceChange).indexOf('reconnect-after-device-error') > -1) {
                        self.showDeviceInUseAlert('microphone');
                    }

                    avDeviceService.setSfuDeviceError(
                        storageService.get('audio-device'),
                        error && error.name ? error.name : error
                    );

                    return; // TODO: should the remaining error handling logic be done here too?
                } else {
                    logger.error('createOfferForSIP->plugin.createOffer.error', 'sip plugin, WebRTC error', error);

                    analyticsWrapperService.eventTrack('Meeting - sip voice call - error', {
                        sfuEvent: true,
                        error: error && error.name ? error.name : error + '',
                        screenshare: is_screen,
                        iceRestart: iceRestart
                    });
                }

                if (!(error && (error.name === 'NotReadableError' || error.name === 'NotAllowedError'))) {
                    if (is_screen) {
                        //We don't expect this case to happen, but we're adding the log and alert just in case
                        self.showAlert(
                            'There was a problem sharing your ' +
                                (is_screen ? (self.fileplay ? 'video file' : 'screen') : 'video') +
                                '.'
                        );
                        logger.error(
                            'createOfferForSIP->plugin.createOffer.error',
                            'sip call failed for screenshare',
                            error
                        );
                        return;
                    } else if (iceRestart) {
                        //We don't expect this case to happen, but we're adding the log and alert just in case
                        $window.swal(self.getDeviceTimeoutSwalOptions());
                        logger.error(
                            'createOfferForSIP->plugin.createOffer.error',
                            'sip call failed for iceRestart',
                            error
                        );
                        return;
                    }
                }

                self.onCreateOfferForSIPError(
                    plugin,
                    error,
                    mediaConstraints,
                    function (proceed, audioError, videoError) {
                        if (proceed) {
                            logger.log(
                                'createOfferForSIP->plugin.createOffer.error',
                                'videoroomCtrl retrying sip call, audioError=' +
                                    audioError +
                                    ', videoError=' +
                                    videoError +
                                    ' sipAttempt=' +
                                    plugin.sipAttempt
                            );

                            var errorName = (error && error.name) || error;
                            if (audioError) {
                                avDeviceService.setSfuDeviceError(storageService.get('audio-device'), errorName);
                            }
                            if (videoError) {
                                avDeviceService.setSfuDeviceError(storageService.get('video-device'), errorName);
                            }

                            if (!is_screen) {
                                var type = (iceRestart ? 'ice-restart' : 'peer-connection') + ':retry';
                                var reason = plugin.sipAttempt
                                    ? 'retry on media error, attempt=' + plugin.sipAttempt
                                    : 'retry on device error';
                                self.msgflowEvent(type, { type: 'audio', reason: reason });
                            }
                            self.createOfferForSIP(is_screen, iceRestart, deviceChange);
                        }
                    }
                );
            };

            if (is_screen && !self.fileplay && self.reuseScreenSDP.enable && self.reuseScreenSDP.saved) {
                var jsep1 = new RTCSessionDescription({
                    type: self.reuseScreenSDP.saved.type,
                    sdp: self.reuseScreenSDP.saved.sdp
                });
                self.customizeSdp(jsep1, undefined, is_screen, true, false);
                logService.log('videoroomCtrl sip applying saved SDP, reused');
                logService.log(jsep1);
                onsuccess(jsep1);
                return;
            }

            // Initially, video is sent, and later if new plugin is used,
            // then video publish is disabled after local stream is created.
            // For screen share, audio send-receive are disabled.
            plugin.createOffer({
                iceRestart: !!iceRestart,
                stream: stream,
                media: mediaConstraints,
                success: onsuccess,
                error: onerror,
                customizeSdp: function (jsep) {
                    // if videocodec or audiocodec is present then this will use that codec here.
                    self.customizeSdp(jsep, undefined, is_screen, true, false);
                },
                rtcConstraints: self.rtcConstraintsAudio || undefined
            });
        }

        // process errors from getUserMedia wrapped in createOfferForSIP.
        // Calls callback(proceed, audioError, videoError) on completion.
        function onCreateOfferForSIPError(plugin, error, media, callback) {
            //For NotReadableError and NotAllowedError (chrome > 91), we want to retry SIP call right away
            //
            //For all other errors, we want to allow up to 3 tries
            //This only applies to non-screenshare SIP calls

            var permissions = avDeviceService.getDevicePermissions();

            //Webcam in use / not accessible
            if (error && (error.name === 'NotReadableError' || error.name === 'NotAllowedError')) {
                if (permissions.videoAllowed || permissions.audioAllowed) {
                    //TODO: not sure this should be set there this way for simply retrying the call in this case.  The permissions are likely allowed, however the
                    //call logic probably isn't set to look at device errors yet.
                    var audioError = false,
                        videoError = false;
                    if (permissions.videoAllowed && !permissions.audioAllowed) {
                        videoError = true;
                    } else if (!permissions.videoAllowed && permissions.audioAllowed) {
                        audioError = true;
                    } else {
                        audioError = (error.message || '').match(/audio/i);
                        videoError = (error.message || '').match(/video/i);
                        if (!audioError && !videoError) {
                            // in case message is not present
                            audioError = videoError = true;
                        }
                    }
                    var device = [];
                    if (audioError) {
                        device.push('microphone');
                    }
                    if (videoError) {
                        device.push('webcam');
                    }
                    if (device.length > 0) {
                        self.showDeviceInUseAlert(device.join(' and '));
                    }
                    // proceed: true
                    callback(true, audioError, videoError);
                } else {
                    //This case shouldn't happen, but adding log to give visibility if it does
                    logger.error(
                        'onCreateOfferForSIPError',
                        `received ${error.name} while audio and video blocked`,
                        error
                    );
                    // proceed: false
                    callback(false);
                }
            } else {
                //Other getUserMedia errors (Timeout, NotFoundError, etc.)

                // in case of excessive wait in timeout error, do not retry.
                var excessive = error && error.name == 'Timeout' && (error.message || '').indexOf(/excessive/) >= 0;

                if (!excessive && plugin.sipAttempt === 1) {
                    // retry with same constraints. (proceed: true)
                    callback(true);
                } else if (!excessive && plugin.sipAttempt === 2 && media.useCamera !== false) {
                    //This will make their mic inactive but still allow them to join a call
                    //In another ticket, we will allow users to re-enable computer audio after initial join: ANYAM-31964
                    // Retry without audio constraints. (proceed: true, audioError: true, videoError: false)
                    callback(true, true, false);
                } else {
                    logService.log('videoroomCtrl showing device timeout message to user, excessive=' + excessive);

                    $window.swal(self.getDeviceTimeoutSwalOptions(), function (confirmed) {
                        if (confirmed) {
                            // Retry without video constraints. (proceed: true, audioError: false, videoError: true)
                            callback(true, false, true);
                        }
                    });
                }
            }
        }

        // To hangup the SIP call for the video publisher.
        function doHangup() {
            var hangup = { request: 'hangup' };
            self.sipcall.send({ message: hangup });
            self.sipcall.state.call = 'terminating';
            self.sipcall.hangup();
            analyticsWrapperService.eventTrack('Meeting - sip voice call - disconnected', { sfuEvent: true });
            // stopMicLevel();
        }
    }
]);
